<div class="content-section disable-auto-scroll" >
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-section h-100 title-bar title-bar-nav" id='title-bar'>
        <div class="title-div d-flex align-items-center">
            <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                <div class="p-0">
                    <a (click)="cancel(cancelmodal)">
                        <img src="assets/ph-bhp-layout/svg/back.svg" class="svg">
                        {{ 'CHECK.BACK' | translate}}
                    </a>
                    <h2 *ngIf="mode=='new'" class="background_title">
                        {{ 'CHECK.QUESTIONS.ADD_QUESTION' | translate}}
                    </h2>
                    <h2 *ngIf="mode=='edit'" class="background_title">
                        {{ 'CHECK.QUESTIONS.EDIT_QUESTION' | translate}}
                    </h2>
                </div>
            </div>
        </div>
    </div>
    <form [formGroup]="formData" #ngForm="ngForm">
        <div class="container-fluid ">
            <div class="d-flex justify-content-between" class="d-flex justify-content-between">
                <div class="py-2 w-100 px-4" >
                    <h2 class="background_title">
                        {{ 'CHECK.QUESTIONS.QUESTION_DETAILS' | translate}}
                    </h2>
                    <div  class="bd-input w-100 mt-4" >
                        <input
                        required
                        formControlName="statement"
                        type="text"
                        placeholder="{{'CHECK.QUESTIONS.QUESTION' | translate}} *"
                        [ngClass]="{'invalidForm':(formData.get('statement').errors
                                        && (formData.get('statement').touched || formData.get('statement').dirty))
                                        || ngForm.submitted}">
                        <div class="underline"></div>
                    </div>
                    <div class="dropdown dropdown-bhp mt-4" style="width: 240px; min-width: 345px;">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input formControlName="questionTypeId" hidden />
                            <input class="dropdown-toggle" type="text" value="{{questionTypeName | translate}}"
                            [ngClass]="{'invalidForm':(formData.get('questionTypeId').errors
                                        && (formData.get('questionTypeId').touched || formData.get('questionTypeId').dirty))
                                        || ngForm.submitted}"
                                        placeholder="{{'CHECK.QUESTIONS.ANSWER_TYPE' | translate }}" readonly/>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                        </div>
                        <ul class="dropdown-menu">
                            <li [ngValue]="questionType" class="dropdown-item" *ngFor="let questionType of questionTypes; let i = index"
                                (click)="onQuestionTypeChange(questionType)"
                                [ngClass]=" ">
                                {{ questionType.questionTypeName | translate }}
                            </li>
                        </ul>
                    </div>
                    <div  class="bd-input bd-text w-100 mt-4" *ngIf="questionType?.showReferenceDesc">
                        <textarea cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                        id="input"
                                        cdkAutosizeMinRows="1" type="text" class="form-input referenceDesc"
                                            formControlName="referenceDesc"
                                            placeholder="{{'CHECK.QUESTIONS.REFERENCE_DESC' | translate}}"
                                            [ngClass]="{'invalidForm':(formData.get('referenceDesc').errors
                                && (formData.get('referenceDesc').touched || formData.get('referenceDesc').dirty))
                                || ngForm.submitted}">
                        </textarea>
                        <div class="underline"></div>
                    </div>
                    <div class="preview-container d-grid" *ngIf="questionTypeId != ''">
                        <label>{{'CHECK.QUESTIONS.PREVIEW' | translate}}</label>
                        <div  class="bd-input w-100 mt-4" *ngIf="questionType?.skin == 'Input'">
                            <input type="text" id="input" required=""
                            readonly
                            placeholder="{{(questionType.onlyNumbers ? 'CHECK.QUESTIONS.ENTER_NUMBER' : 'CHECK.QUESTIONS.ENTER_TEXT') | translate}}">
                        </div>
                        <div  *ngIf="questionType?.skin == 'Radio' || questionType?.skin == 'Checkbox'" [ngClass]="'preview-'+questionType?.skin.toLowerCase() ">
                            <div *ngIf="questionType?.answerOptions?.length > 0" class="d-flex"  >
                                <div *ngFor="let answerOption of questionType.answerOptions" class="m-3 radioOpt" [ngClass]="'caption-position-'+questionType.captionPosition.toLowerCase()">
                                    <label *ngIf="questionType.captionPosition != 'None' && (questionType.captionPosition == 'Top' || questionType.captionPosition == 'Left')"
                                            class="before-label form-check-label" for="{{answerOption.id}}">{{answerOption.caption | translate}}</label>
                                    <input type="radio"  name="{{answerOption.id}}" class="form-check-input" disabled
                                    [value]="false" id="{{answerOption.id}}">
                                    <label *ngIf="questionType.captionPosition != 'None' && (questionType.captionPosition == 'Bottom' || questionType.captionPosition == 'Right')"
                                        class="before-label form-check-label" for="{{answerOption.id}}">{{answerOption.caption | translate}}</label>
                                </div>
                            </div>
                            <div *ngIf="questionType?.answerOptions?.length == 0 " class="d-flex">
                                <div *ngFor="let answerOption of options" class="m-3 radioOpt" [ngClass]="'caption-position-'+questionType.captionPosition.toLowerCase()">
                                    <label *ngIf="questionType.captionPosition != 'None' && (questionType.captionPosition == 'Top' || questionType.captionPosition == 'Left')"
                                            class="before-label form-check-label" for="{{answerOption.id}}">{{answerOption.caption | translate}}</label>
                                    <input type="radio"  name="{{answerOption.id}}" class="form-check-input" disabled
                                    [value]="false" id="{{answerOption.id}}">
                                    <label *ngIf="questionType.captionPosition == 'Bottom' || questionType.captionPosition == 'Right'"
                                        class="before-label form-check-label" for="{{answerOption.id}}">{{answerOption.caption | translate}}</label>

                                </div>
                            </div>
                        </div>
                        <div class="stars-container d-flex" *ngIf="questionType?.skin == 'Star'" >
                            <div *ngFor="let answerOption of options" class="star-div" >
                            </div>
                        </div>
                        <div class="stars-container d-flex" *ngIf="questionType?.skin == 'Dropdown'" >
                            <div class="dropdown dropdown-bhp mt-4" style="width: 240px; min-width: 345px;">
                                <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false" disabled>
                                    <input  hidden />
                                    <input class="dropdown-toggle preview" type="text" value="{{'SOP_MANAGEMENT.OPTIONS' | translate}}"
                                    [ngClass]="" disabled readonly/>
                                    <span class="label-dropdown">{{ 'CHECK.QUESTIONS.SELECT_OPTION' | translate }}*</span>
                                    <img class="dropdown-arrow mt-2" src="assets/icons/arrowDropdownOutlined.svg"  />
                                </div>
                            </div>
                        </div>
                        <div class="stars-container d-flex" *ngIf="questionType?.skin == 'Multiselect'" >
                            <div class="dropdown dropdown-bhp mt-4" style="width: 240px; min-width: 345px;">
                                <div class="dummy-multiselect k-selection-multiple d-flex"  disabled>
                                    <span class="k-chip-solid-base">{{ 'CHECK.EDITOR.OPTION' | translate }} 1</span>
                                    <span class="k-chip-solid-base">{{ 'CHECK.EDITOR.OPTION' | translate }} 2</span>
                                    <span class="label-dropdown">{{ 'CHECK.QUESTIONS.SELECT_OPTION' | translate }}</span>
                                    <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        <div class="container-fluid mt-4">
            <h2 class="background_title">
                {{ 'CHECK.QUESTIONS.CONFIGURATION' | translate}}
            </h2>
            <div>
                <h2 class="background_title section-line mt-2">
                    {{ 'CHECK.QUESTIONS.QUESTIONNAIRE_SETTINGS' | translate}}
                </h2>
                <div class="sections-container">
                    <div class="section">
                        <div class="d-flex justify-content-between">
                            <div class="section-head">
                                <h2 class="section-title">{{ 'CHECK.QUESTIONS.SHOW_INFO_SECTION' | translate}} </h2>
                                <label class="section-subtitle">{{ 'CHECK.QUESTIONS.INFO_SECTION_DESC' | translate}}</label>
                            </div>

                            <div class="d-flex mx-4 align-items-center">
                                <label class="switch mr-3 d-block">
                                    <input type="checkbox" formControlName="showInfo" id="showInfo" name="showInfo">
                                    <span class="slider round" [ngClass]=""></span>
                                </label>
                                <label class="switch-label" for="showInfo">{{ 'CHECK.QUESTIONS.VISIBLE' | translate }}</label>
                            </div>
                        </div>
                        <div *ngIf="formData.controls['showInfo'].value">
                            <div  class="bd-input w-100 mt-4" >
                                <textarea id="input" formControlName="infoSection" required class="" [ngClass]="{'invalidForm':(formData.get('infoSection').errors
                                  && (formData.get('infoSection').touched || formData.get('infoSection').dirty))
                                  || ngForm.submitted}" placeholder="{{'CHECK.QUESTIONS.INFO_SECTION_PLACEHOLDER' | translate}} *">
                                </textarea>
                            </div>
                        </div>
                    </div>
                    <div class="section">
                        <div class="d-flex justify-content-between">
                            <div class="section-head">
                                <h2 class="section-title">{{ 'CHECK.QUESTIONS.SHOW_FORMAL_BASIS' | translate}}</h2>
                                <label class="section-subtitle">{{ 'CHECK.QUESTIONS.FORMAL_BASIS_DESC' | translate}}</label>
                            </div>

                            <div class="d-flex mx-4 align-items-center">
                                <label class="switch mr-3 d-block">
                                    <input type="checkbox" formControlName="showFormalBasis"  id="showFormalBasis" name="showFormalBasis">
                                    <span class="slider round" [ngClass]=""></span>
                                    </label>
                                    <label class="switch-label" for="showFormalBasis">{{ 'CHECK.QUESTIONS.VISIBLE' | translate }}</label>
                            </div>
                        </div>
                        <div *ngIf="formData.controls['showFormalBasis'].value">
                            <div  class="bd-input w-100 mt-4" >
                                <textarea id="input" formControlName="infoFormalBasis" required class="" [ngClass]="{'invalidForm':(formData.get('infoFormalBasis').errors
                                  && (formData.get('infoFormalBasis').touched || formData.get('infoFormalBasis').dirty))
                                  || ngForm.submitted}" placeholder="{{'CHECK.QUESTIONS.FORMAL_BASIS_PLACEHOLDER' | translate}} *">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="div-settings">
                <h2 class="background_title section-line">
                    {{ 'CHECK.QUESTIONS.REPORT_SETTINGS' | translate}}
                </h2>
                <div class="sections-container">
                    <div class="sections-inner">
                        <div class="d-flex justify-content-between">
                            <div class="section-head">
                                <h2 class="section-title">{{ 'CHECK.QUESTIONS.SHOW_THEME' | translate}}</h2>
                                <label class="section-subtitle">{{ 'CHECK.QUESTIONS.THEME_DESC' | translate}}</label>
                            </div>

                            <!-- <div class="d-flex mx-4 align-items-center"> // HHP-8820
                                <label class="visible-label mr-3 d-block">{{ 'CHECK.QUESTIONS.VISIBLE' | translate }}</label>
                            </div> -->

                        </div>
                        <div  class="bd-input mt-4" >
                            <input type="text" id="input" formControlName="themeSection" required=""
                            placeholder="{{'CHECK.QUESTIONS.THEME_PLACEHOLDER' | translate }} *"
                            class=""
                            [ngClass]="{'invalidForm':(formData.get('themeSection').errors
                            && (formData.get('themeSection').touched || formData.get('themeSection').dirty))
                            || ngForm.submitted}"
                            >
                            <div class="underline"></div>
                        </div>
                    </div>
                    <div class="sections-inner">
                        <div class="d-flex justify-content-between">
                            <div class="section-head">
                                <h2 class="section-title">{{ 'CHECK.QUESTIONS.SHOW_ASSESSMENT' | translate}}</h2>
                                <label class="section-subtitle">{{ 'CHECK.QUESTIONS.ASSESSMENT_DESC' | translate }} {{ (isYesNoQuestion() ? 'CHECK.QUESTIONS.YES_NO_DESCRIPTION' : 'CHECK.QUESTIONS.REMAINING_DESCRIPTION' ) | translate }}</label>
                            </div>

                            <!-- <div class="d-flex mx-4 align-items-center"> // HHP-8821
                                <label class="visible-label mr-3 d-block">
                                   {{ 'CHECK.QUESTIONS.VISIBLE' | translate }}</label>
                            </div> -->

                        </div>
                        <div class="assessments-container">
                            <div class="assessment-div" (click)="defaultAssessment(true)">
                                <input type="radio"  formControlName="defaultAssessmentParagraph" name="assessment" class="form-check-input"
                                   [value]="true" id="default">
                                <label class="form-check-label" for="periodMonth">{{ 'CHECK.QUESTIONS.ASSESSMENT_DEFAULT' | translate}}</label>
                            </div>
                            <div class="assessment-div" (click)="defaultAssessment(false)">
                                <input type="radio"  formControlName="defaultAssessmentParagraph" name="assessment" class="form-check-input"
                                   [value]="false" id="new">
                                <label class="form-check-label" for="periodMonth">{{'CHECK.QUESTIONS.ASSESSMENT_NEW' | translate}}</label>
                            </div>
                        </div>
                        <div  class="bd-input w-100 mt-4" *ngIf="!formData.controls['defaultAssessmentParagraph'].value">
                            <textarea formControlName="assessmentParagraph" id="input" required="" (keyup)="autoGrowTextZone($event)"
                            class=""
                            placeholder="{{'CHECK.QUESTIONS.ASSESSMENT_NEW' | translate}} *"
                            [ngClass]="{'invalidForm':(formData.get('assessmentParagraph').errors
                            && (formData.get('assessmentParagraph').touched || formData.get('assessmentParagraph').dirty))
                            || ngForm.submitted}"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="question-footer d-flex justify-content-end">
        <button class="btn btn-cancel mr-4 d-flex align-items-center" (click)="cancel(cancelmodal)">{{ 'BUTTON.CANCEL' | translate }}</button>
        <button class="btn btn-confirm btn-confirm-custom d-flex align-items-center" (click)="saveQuestion()">{{ 'AUTHORIZATION.SAVE' | translate }}</button>
    </div>
</div>


<ng-template #cancelmodal>
    <div class="modal-header bhp-modal-header">
        <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class=" modal-body bhp-modal-body">
        <p class="">
            {{'CHECK.QUESTIONS.CLOSE_WITHOUT_SAVING' | translate}}
        </p>
    </div>
    <div class="d-flex justify-content-end">
      <div class="align-items-end d-flex">
        <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
        <button (click)="goBack();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.LEAVE' | translate }}</button>
      </div>
    </div>
</ng-template>
